import React, { ChangeEvent } from 'react';
import { connect } from 'react-redux';
import { Input, Label } from 'reactstrap';
import * as actions from '../../../actions';
import { getTranslationKey } from '../../../modules/utils/helpers';
import {
  normalizeUploadEndpoint,
  UPLOAD_ENDPOINT_OPTIONS
} from '../../../modules/constants/uploadEndpoint';
import { EndpointKey } from '../../../modules/types/uploadEndpoint';

interface Auth {
  uploadEndpoint?: string | null;
  [key: string]: any;
}

interface UploadEndpointSelectProps {
  auth: Auth;
  updateUploadEndpoint: (data: { uploadEndpoint: EndpointKey }) => void;
}

const UploadEndpointSelect: React.FC<UploadEndpointSelectProps> = ({
  auth,
  updateUploadEndpoint
}) => (
  <div>
    <Label className="font-weight-bold">{getTranslationKey('uploadEndpoint.selectLabel')}:</Label>
    <Input
      type="select"
      value={normalizeUploadEndpoint(auth.uploadEndpoint)}
      onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
        updateUploadEndpoint({ uploadEndpoint: value as EndpointKey });
      }}
    >
      {UPLOAD_ENDPOINT_OPTIONS.map((option) => (
        <option key={option.value} value={option.value}>
          {getTranslationKey(option.labelKey)}
        </option>
      ))}
    </Input>
  </div>
);

const mapStateToProps = ({ auth }: any) => ({ auth });

export default connect(mapStateToProps, actions)(UploadEndpointSelect);
